import React from 'react';
import { goToLPDetailUtil } from '../../../utils/AppUtils';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

const ActionPathCard = ({ index,action }) => {
    const navigate = useNavigate();
    
    return (
        <div key={index} className={`action-path-slide cursor-pointer`} onClick={() => {goToLPDetailUtil(action, navigate, 1)}}  tabIndex="0" aria-label='Action Path'>
                                    {!_.isEmpty(action?.cover_url)?
                                    // <img className='action-path-box-img img-fluid' src={action?.cover_url} alt="Action Path" tabIndex="0" aria-lable="Action Path"/>:
                                    <div className={`action-path-box position-relative`}>
                                        <div className="img-box-pat">
                                            <img src={action?.cover_url} alt="action path" className='img-fluid' />
                                        </div>
                                        <div className='content-box-pat'>
                                            <h3 title={action.lp_name} aria-label={action.lp_name}>{action.lp_name}</h3>
                                             <p
                                            title={action.category_name?.replace(/<[^>]+>/g, '')} // remove HTML tags for title
                                            dangerouslySetInnerHTML={{ __html: action.category_name }}
                                            ></p>
                                        </div>
                                    </div>:
                                    <></>}
                                    {false && <div className={`action-path-box ${action.color}`}>
                                        <div className="img-box-pat">
                                            <img src={action.thumbnail} alt="action path" className='img-fluid' />
                                        </div>
                                        <div className='content-box-pat'>
                                            <h3>{action.lp_name}</h3>
                                            <p dangerouslySetInnerHTML={{
                                               __html: action.category_name,
                                            }}></p>
                                        </div>
                                    </div>}
                                </div>
    );
};

export default ActionPathCard;